import api, { request } from '../../../api';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAdminPlayerEnrollmentsStore } from './store';

export interface IAdminPlayerEnrollmentsActions extends IActionGroup {
  getByUserId: (
    clubId: number,
    userId?: number
  ) => { playerEnrollments?: IAdminPlayerEnrollmentsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  getByUserId: async (state: IStore, clubId: number, userId?: number) => {
    const response = await request.get(`${api.admin.clubs}${clubId}/enrollments/?user=${userId}`);

    if (response.error) {
      return {
        errors: { adminPlayerEnrollments: { msg: 'Error retrieving the user enrollments.' } }
      };
    }

    return {
      adminPlayerEnrollments: {
        ...state.adminPlayerEnrollments,
        [clubId]: response
      }
    };
  }
};

export default actions;
